require("jquery");
require("bootstrap");
require("@fortawesome/fontawesome-free");
require("slick-carousel");
require("jquery-mask-plugin/dist/jquery.mask.min");

window._ = require("lodash");

try {
  window.Popper = require("@popperjs/core").default;
  window.$ = window.jQuery = require("jquery");
} catch (e) {}

jQuery(function () {
  themeColor();
  masks();
  fixaMenu();
  menuScroll();

  $(window).scroll(function () {
    fixaMenu();
  });

  $(window).on("resize", function () {
    fixaMenu();
  });

  $(window).ready(function () {});

  $(window).on("load", function () {});

  //Adiciona cor principal do thema nos meta tags do header
  function themeColor() {
    const themeColor = $(
      '[name="theme-color"], [name="msapplication-navbutton-color"], [name="msapplication-TileColor"]'
    );
    const value = getComputedStyle(document.documentElement).getPropertyValue(
      "--bs-primary"
    );
    themeColor.attr("content", value);
  }

  //Adiciona pré-definidas, com base nos nomes, id ou types de inputs
  function masks() {
    //Telefone
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, "").length === 11
          ? "(00) 00000-0000"
          : "(00) 0000-00009";
      },
      spOptions = {
        onKeyPress: function (val, e, field, options) {
          field.mask(SPMaskBehavior.apply({}, arguments), options);
        },
      };
    $('.mask-phone , [type="tel"], [id="tel"]').mask(SPMaskBehavior, spOptions);

    //CEP
    let cep = $('.mask-cep, [name="cep"], [id="cep"]');
    cep.mask("00000-000", {
      reverse: true,
    });
    cep.attr("inputmode", "numeric");

    //CPF
    let cpf = $('.mask-cpf, [name="cpf"], [id="cpf"]');
    cpf.mask("000.000.000-00", {
      reverse: true,
    });
    cpf.attr("inputmode", "numeric");

    //CNPJ
    let cnpj = $('.mask-cnpj, [name="cnpj"], [id="cnpj"]');
    cnpj.mask("00.000.000/0000-00", {
      reverse: true,
    });
    cnpj.attr("inputmode", "numeric");

    //CPF ou CNPJ
    let cpfCnpj = $('.mask-cpf-cnpj, [name="cpf-cnpj"], [id="cpf-cnpj"]');
    let options = {
      onKeyPress: function (cpf, ev, el, op) {
        let masks = ["000.000.000-000", "00.000.000/0000-00"];
        cpfCnpj.mask(cpf.length > 14 ? masks[1] : masks[0], op);
      },
    };
    cpfCnpj.length > 11
      ? cpfCnpj.mask("00.000.000/0000-00", options)
      : cpfCnpj.mask("000.000.000-00#", options);
    cpfCnpj.attr("inputmode", "numeric");

    //Data
    let date = $('.mask-date, [name="date"], [id="date"], [type="date"]');
    date.mask("00/00/0000", {
      reverse: true,
    });
    date.attr("inputmode", "numeric");
  }

  function menuScroll() {
    $(".nav li a").on("click", function () {
      let valorAtual = $(this).attr("href");
  
      $("html, body").animate(
        {
          scrollTop: $(valorAtual).offset().top - 200,
        },
        800
      );
  
      return false;
    });
  }

  //fixa menu
  function fixaMenu() {
    let valor = 200;
    let w = $(window).width();
    let rolagem = $(window).scrollTop();
    if (w > 960) {
      // if (!$("#modeloHome").hasClass("modeloHome")) {
      //   $("#topo").addClass("ativo");
      //   $("#topo").addClass("ativoInterna");
      // }
      if (rolagem > valor) {
        $("#topo").addClass("ativo");
        $("#topo").removeClass("ativoInterna");
      } else {
        //if ($("#modeloHome").hasClass("modeloHome")) {
        $("#topo").removeClass("ativo");
        //}
      }
    } else {
      $("#topo").addClass("ativo");
      $("#topo").removeClass("ativoInterna");
    }
  }

  //carrosseis
  // $('.carrossel-banner').slick({
  //   infinite: true,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   dots: true,
  //   arrows: false,
  // });
  
  $("#banner").slick({
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: true,
    speed: 300,
  });

  $(".carrossel-equipe").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".carrossel-servicos").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".carrossel-clientes").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".carrossel-depoimentos").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".carrossel-cases").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  

  $(".vertexto").click(function () {
    var itemId = $(this).data("item-id");
    $("#conteudo_" + itemId).toggleClass("d-none");
  });

  //blur modal

  $("#exampleModal").on("show.bs.modal", function () {
    $("body").addClass("modal-open");
    setTimeout(() => {
      $(".carrossel-modal").show();
      $(".carrossel-modal").slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }, "500");
  });

  $("#exampleModal").on("hidden.bs.modal", function () {
    $("body").removeClass("modal-open");
  });

  $("#exampleModalTwo").on("show.bs.modal", function () {
    $("body").addClass("modal-open");
    setTimeout(() => {
      $(".carrossel-modal-2").show();
      $(".carrossel-modal-2").slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }, "500");
  });

  $("#exampleModalTwo").on("hidden.bs.modal", function () {
    $("body").removeClass("modal-open");
  });

  $("#exampleModalThre").on("show.bs.modal", function () {
    $("body").addClass("modal-open");
    setTimeout(() => {
      $(".carrossel-modal-3").show();
      $(".carrossel-modal-3").slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }, "500");
  });

  $("#exampleModalThre").on("hidden.bs.modal", function () {
    $("body").removeClass("modal-open");
  });

  $("#exampleModalFour").on("show.bs.modal", function () {
    $("body").addClass("modal-open");
    setTimeout(() => {
      $(".carrossel-modal-4").show();
      $(".carrossel-modal-4").slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }, "500");
  });

  $("#exampleModalFour").on("hidden.bs.modal", function () {
    $("body").removeClass("modal-open");
  });
});
